/**
 * Created by jansen on 22.06.17.
 */
import React from "react";
import {CHAT, DUMMY, LOGIN} from "../reducers/router"
import Chat from "./admin/Chats";
import Dummy from "./testClient/Dummy";
import Login from "./login/Login";

export default ({nav, style}) => (
    <div>{getComponent(nav, style)}</div>
);

const getComponent = (nav, style) => {
    switch (nav.route) {
        case CHAT:
            return <Chat chat={nav.selected}/>;
        case DUMMY:
            return <Dummy />;
        case LOGIN:
            return <Login/>;
        default:
            return <h1>Empty</h1>
    }
};




// WEBPACK FOOTER //
// ./src/components/ContentSwitcher.js